<template>
  <div class="max-w-lg w-full bg-black text-white p-4 mb-3 md:mb-12 flex flex-wrap border-l-24 border-red">
    <div class="pr-4 mb-3 md:mb-0 w-full">
      <p>
        We noticed this festival is using the older date functionality.
        Would you like to convert it over to use the new setup?
      </p>
      <div class="pt-4">
        <button :disabled="loading" @click="convertFestival" class="px-3 py-2 text-black font-sans-bold text-center inline-block bg-white uppercase no-underline font-bold">
          <span v-if="!loading">
            Convert
          </span>
          <span class="italic" v-else>
            Converting now...
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['id'],
  name: "OldDateConvertBanner",
  data() {
    return {
      loading: false
    }
  },
  computed: {
    migrateApiPath() {
      return this.$laroute.route('api.admin.festival.migrate', {
        festival: this.id
      })
    }
  },
  methods: {
    async convertFestival() {
      if (!window.confirm('Are you sure? This cannot be undone!') || this.loading) {
        return;
      }

      this.loading = true;

      await axios.post(this.migrateApiPath).catch(r => r.response);
      location.reload();
    }
  }
}
</script>

<style scoped>

</style>
